import {
  Collection1k04j3hzsbod0 as Collection,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID3gxj6tk5isa35 as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  HashMap1a0ld5kgwhmhv as HashMap,
  toMutableList20rdgwi7d3cwi as toMutableList,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  toMutableMapr5f3w62lv8sk as toMutableMap,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  KtMap140uvy3s5zad8 as KtMap,
  isInterface3d6p8outrmvmk as isInterface,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  addAll21mdhg523wnoa as addAll,
  KtMutableList1beimitadwkna as KtMutableList,
  AbstractList3ck35puwbp1e9 as AbstractList,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  AbstractMutableList192xfq8ycgofs as AbstractMutableList,
  copyToArray2j022khrow2yi as copyToArray,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
  joinToStringxqcavsxcmh4q as joinToString,
  protoOf180f3jzyo7rfj as protoOf,
  RandomAccess1jbw8sdogqb8x as RandomAccess,
} from './kotlin-kotlin-stdlib.mjs';
import { get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock } from './kotlinx-atomicfu.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class DoubleList {}
function getAt(index) {
  return this.u2(index);
}
function toDoubleArray() {
  var tmp = 0;
  var tmp_0 = this.s2();
  var tmp_1 = new Float64Array(tmp_0);
  while (tmp < tmp_0) {
    var tmp_2 = tmp;
    tmp_1[tmp_2] = this.u2(tmp_2);
    tmp = tmp + 1 | 0;
  }
  return tmp_1;
}
function listIterator() {
  return this.x2(0);
}
function listIterator_0(index) {
  return this.t4(index, this.s2()).s4();
}
function subList(fromIndex, toIndex) {
  return SimpleSubList(fromIndex, toIndex, DoubleList$subList$lambda(this));
}
function contains(element) {
  return containsCheck(this, element);
}
function containsAll(elements) {
  return containsAllCheck(this, elements);
}
function isEmpty() {
  return this.s2() === 0;
}
function iterator() {
  return this.s4();
}
class Mixin {
  constructor(extra) {
    extra = extra === VOID ? null : extra;
    this.n9u_1 = extra;
  }
  o9u(_set____db54di) {
    this.n9u_1 = _set____db54di;
  }
  p9u() {
    return this.n9u_1;
  }
}
class Property {
  constructor(name, defaultGen) {
    name = name === VOID ? null : name;
    this.q9u_1 = name;
    this.r9u_1 = defaultGen;
  }
}
class PropertyThis {
  constructor(name, defaultGen) {
    name = name === VOID ? null : name;
    this.s9u_1 = name;
    this.t9u_1 = defaultGen;
    var tmp = this;
    tmp.u9u_1 = Extra$PropertyThis$transform$lambda;
  }
}
class ExtraObject {
  constructor() {
    var tmp = this;
    // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
    tmp.v9u_1 = get_atomicfu$reentrantLock();
    this.w9u_1 = HashMap.s9();
    var tmp_0 = this;
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.v9u_1;
    tmp_0.x9u_1 = toMutableList(this.w9u_1.y4());
  }
  s2() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.v9u_1;
    return this.w9u_1.s2();
  }
  i3() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.v9u_1;
    // Inline function 'kotlin.collections.associateWith' call
    var this_0 = this.w9u_1.x4();
    var result = LinkedHashMap.cd(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp$ret$5 = this.w9u_1.w4(element);
      result.b5(element, tmp$ret$5);
    }
    return toMutableSet(toMutableMap(result).i3());
  }
  x4() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.v9u_1;
    return toMutableSet(this.w9u_1.x4());
  }
  y4() {
    return this.x9u_1;
  }
  wi(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.v9u_1;
    return this.w9u_1.w4(key);
  }
  w4(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.wi((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  y9u(key, value) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.v9u_1;
    // Inline function 'kotlin.collections.set' call
    this.w9u_1.b5(key, value);
    return Unit_instance;
  }
  z9u(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.v9u_1;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.w9u_1;
    return (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).u4(key);
  }
  n1() {
    return this.s2() === 0;
  }
  a5() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.v9u_1;
    this.w9u_1.a5();
    return Unit_instance;
  }
  t7a(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.v9u_1;
    return this.w9u_1.c5(key);
  }
  c5(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.t7a((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  a9v(from) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.v9u_1;
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = from.i3().p1();
    while (_iterator__ex2g4s.q1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.j3();
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.k3();
      // Inline function 'kotlin.collections.set' call
      this.w9u_1.b5(key, value);
    }
    return Unit_instance;
  }
  d5(from) {
    return this.a9v(from);
  }
  b9v(key, value) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.v9u_1;
    // Inline function 'kotlin.collections.set' call
    this.w9u_1.b5(key, value);
    return Unit_instance;
  }
  b5(key, value) {
    return this.b9v((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE(), value);
  }
  u2f(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.v9u_1;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.w9u_1;
    return (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).u4(key);
  }
  u4(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.u2f((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
}
class MutableListEx {}
function setAddAll(index, elements, offset, size) {
  // Inline function 'kotlin.math.min' call
  var b = this.s2() - index | 0;
  var setCount = Math.min(size, b);
  this.j9v(index, elements, offset, setCount);
  this.k9v(elements, offset + setCount | 0, size - setCount | 0);
}
function setAddAll$default(index, elements, offset, size, $super) {
  offset = offset === VOID ? 0 : offset;
  size = size === VOID ? elements.s2() - offset | 0 : size;
  var tmp;
  if ($super === VOID) {
    this.i9v(index, elements, offset, size);
    tmp = Unit_instance;
  } else {
    setAddAll(index, elements, offset, size);
    tmp = Unit_instance;
  }
  return tmp;
}
function setAll(index, elements, offset, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this.e5(index + n | 0, elements.u2(offset + n | 0));
    }
     while (inductionVariable < size);
}
function addAll_0(elements, offset, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this.d2(elements.u2(offset + n | 0));
    }
     while (inductionVariable < size);
}
function removeToSize(size) {
  this.k8(size, this.s2());
}
class SimpleSubList$1 extends AbstractList {
  constructor($toIndex, $fromIndex, $get) {
    return new.target.o9v($toIndex, $fromIndex, $get);
  }
  static o9v($toIndex, $fromIndex, $get, $box) {
    if ($box === VOID)
      $box = {};
    $box.l9v_1 = $toIndex;
    $box.m9v_1 = $fromIndex;
    $box.n9v_1 = $get;
    return this.mj($box);
  }
  s2() {
    return this.l9v_1 - this.m9v_1 | 0;
  }
  u2(index) {
    if (!(0 <= index ? index < this.s2() : false))
      throw IndexOutOfBoundsException.ve();
    return this.n9v_1(index + this.m9v_1 | 0);
  }
}
class Fixed {
  constructor(value) {
    this.p9v_1 = value;
  }
  q9v() {
    return this.p9v_1;
  }
  toString() {
    return 'Fixed(value=' + toString(this.p9v_1) + ')';
  }
  hashCode() {
    return hashCode(this.p9v_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Fixed))
      return false;
    var tmp0_other_with_cast = other instanceof Fixed ? other : THROW_CCE();
    if (!equals(this.p9v_1, tmp0_other_with_cast.p9v_1))
      return false;
    return true;
  }
}
class FastArrayList extends AbstractMutableList {
  constructor(__array) {
    return new.target.r9v(__array);
  }
  static r9v(__array) {
    var $this = this.i8();
    $this.d9v_1 = __array;
    return $this;
  }
  static f9v() {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return this.r9v(tmp$ret$0);
  }
  static e9v(initialCapacity) {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return this.r9v(tmp$ret$0);
  }
  s2() {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.d9v_1.length;
  }
  u2(index) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.d9v_1[rangeCheck(this, index)];
  }
  e5(index, element) {
    rangeCheck(this, index);
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.apply' call
    var this_0 = this.d9v_1[index];
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'korlibs.datastructure.set' call
    // Inline function 'kotlin.js.asDynamic' call
    this.d9v_1[index] = element;
    return this_0;
  }
  d2(element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.d9v_1.push(element);
    this.x7_1 = this.x7_1 + 1 | 0;
    return true;
  }
  f5(index, element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.d9v_1.splice(insertionRangeCheck(this, index), 0, element);
    this.x7_1 = this.x7_1 + 1 | 0;
  }
  t2(elements) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(elements);
    return _addAll(this, tmp$ret$0);
  }
  g5(index) {
    rangeCheck(this, index);
    this.x7_1 = this.x7_1 + 1 | 0;
    var tmp;
    if (index === 0) {
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.d9v_1.shift();
    } else if (index === get_lastIndex(this)) {
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.d9v_1.pop();
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.d9v_1.splice(index, 1)[0];
    }
    return tmp;
  }
  z4(element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.d9v_1;
    var inductionVariable = 0;
    var last = array.length;
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$3 = array[index];
        if (equals(tmp$ret$3, element)) {
          array.splice(index, 1);
          this.x7_1 = this.x7_1 + 1 | 0;
          return true;
        }
      }
       while (inductionVariable < last);
    return false;
  }
  k8(fromIndex, toIndex) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.d9v_1.splice(fromIndex, toIndex - fromIndex | 0);
    this.x7_1 = this.x7_1 + 1 | 0;
  }
  a5() {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.d9v_1.length = 0;
    this.x7_1 = this.x7_1 + 1 | 0;
  }
  y2(element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.d9v_1.indexOf(element);
  }
  toString() {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = this.d9v_1;
    return '[' + joinToString(tmp$ret$3, ', ') + ']';
  }
  j9() {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.d9v_1.concat();
  }
  toArray() {
    return this.j9();
  }
}
//endregion
function DoubleList$subList$lambda(this$0) {
  return (it) => this$0.u2(it);
}
function Extra$PropertyThis$transform$lambda(_this__u8e3s4, it) {
  return it;
}
function getExtra(_this__u8e3s4, name) {
  var tmp3_safe_receiver = _this__u8e3s4.p9u();
  return tmp3_safe_receiver == null ? null : tmp3_safe_receiver.wi(name);
}
function setExtra(_this__u8e3s4, name, value) {
  if (_this__u8e3s4.p9u() == null) {
    if (value == null)
      return Unit_instance;
    _this__u8e3s4.o9u(ExtraTypeCreate());
  }
  var tmp4_safe_receiver = _this__u8e3s4.p9u();
  if (tmp4_safe_receiver == null)
    null;
  else {
    tmp4_safe_receiver.y9u(name, value);
  }
}
function hasExtra(_this__u8e3s4, name) {
  var tmp2_safe_receiver = _this__u8e3s4.p9u();
  return (tmp2_safe_receiver == null ? null : tmp2_safe_receiver.z9u(name)) === true;
}
function getExtraTyped(_this__u8e3s4, name) {
  var tmp = _this__u8e3s4.p9u();
  var tmp1_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
  return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.w4(name);
}
function ExtraTypeCreate() {
  return new ExtraObject();
}
function fastArrayListOf(values) {
  // Inline function 'kotlin.also' call
  var this_0 = FastArrayList.e9v(values.length);
  addAll(this_0, values);
  return this_0;
}
function toFastList(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = FastArrayList.e9v(_this__u8e3s4.length);
  // Inline function 'korlibs.datastructure.fastForEach' call
  var n = 0;
  while (n < _this__u8e3s4.length) {
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = _this__u8e3s4[_unary__edvuaz];
    this_0.d2(it);
  }
  return this_0;
}
function toFastList_0(_this__u8e3s4, out) {
  out = out === VOID ? FastArrayList.f9v() : out;
  out.g9v(0, _this__u8e3s4);
  out.h9v(_this__u8e3s4.s2());
  return out;
}
function SimpleSubList(fromIndex, toIndex, get) {
  return SimpleSubList$1.o9v(toIndex, fromIndex, get);
}
function containsCheck(collection, element) {
  var _iterator__ex2g4s = collection.p1();
  while (_iterator__ex2g4s.q1()) {
    var v = _iterator__ex2g4s.r1();
    if (equals(v, element))
      return true;
  }
  return false;
}
function containsAllCheck(collection, elements) {
  var elementsMap = toMutableSet(elements);
  var _iterator__ex2g4s = collection.p1();
  while (_iterator__ex2g4s.q1()) {
    var v = _iterator__ex2g4s.r1();
    elementsMap.z4(v);
  }
  return elementsMap.n1();
}
function Resourceable(value) {
  return new Fixed(value);
}
function _addAll($this, elements) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (elements.length === 0)
    return false;
  // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = $this.d9v_1;
  (function () {
    var $externalVarargReceiverTmp = tmp$ret$1;
    return $externalVarargReceiverTmp.push.apply($externalVarargReceiverTmp, [].slice.call(elements.slice()));
  }.call(this));
  $this.x7_1 = $this.x7_1 + 1 | 0;
  return true;
}
function rangeCheck($this, index) {
  if (index < 0 || index >= $this.s2())
    throw IndexOutOfBoundsException.h3('index: ' + index + ', size: ' + $this.s2());
  return index;
}
function insertionRangeCheck($this, index) {
  if (index < 0 || index > $this.s2())
    throw IndexOutOfBoundsException.h3('index: ' + index + ', size: ' + $this.s2());
  return index;
}
//region block: post-declaration
initMetadataForInterface(DoubleList, 'DoubleList', VOID, VOID, [Collection]);
initMetadataForClass(Mixin, 'Mixin', Mixin);
initMetadataForClass(Property, 'Property');
initMetadataForClass(PropertyThis, 'PropertyThis');
initMetadataForClass(ExtraObject, 'ExtraObject', ExtraObject, VOID, [KtMutableMap]);
initMetadataForInterface(MutableListEx, 'MutableListEx', VOID, VOID, [KtMutableList]);
initMetadataForClass(SimpleSubList$1);
initMetadataForClass(Fixed, 'Fixed', VOID, VOID, VOID, [0]);
protoOf(FastArrayList).k9v = addAll_0;
protoOf(FastArrayList).i9v = setAddAll;
protoOf(FastArrayList).g9v = setAddAll$default;
protoOf(FastArrayList).j9v = setAll;
protoOf(FastArrayList).h9v = removeToSize;
initMetadataForClass(FastArrayList, 'FastArrayList', FastArrayList.f9v, VOID, [MutableListEx, RandomAccess]);
//endregion
//region block: exports
export {
  containsAll as containsAll1oa5i6t9xmbdv,
  contains as containsteg8664aaglk,
  getAt as getAt237u54ctbxwvd,
  isEmpty as isEmptyrqh4vz39e0v6,
  iterator as iterator300ls4j24zqzz,
  listIterator as listIterator247sl90ooi4qv,
  listIterator_0 as listIterator1a2ckgeamf7jc,
  subList as subList28p829u9d5w23,
  DoubleList as DoubleList2honu8rif2roh,
  Mixin as Mixin3lmkm5hum2vdj,
  PropertyThis as PropertyThis2r0hbk1cs09wj,
  Property as Property1m5vulkepgwzd,
  FastArrayList as FastArrayListw5fr1wlp4slq,
  fastArrayListOf as fastArrayListOf1rdodhrpn0q8y,
  getExtraTyped as getExtraTyped8zexqxz5xxli,
  getExtra as getExtra307y0o9pd6mp3,
  hasExtra as hasExtra1969mplo13qgb,
  setExtra as setExtra314k0z6q35eku,
  toFastList_0 as toFastList1btvvxvv57pw,
  toFastList as toFastListzo2jtkrx0z5y,
  Resourceable as Resourceable38whwgli3ts8g,
};
//endregion
